import PropTypes from 'prop-types';

import ProductIncludes from './ProductIncludes/ProductIncludes';
import GraduationProfile from './GraduationProfile/GraduationProfile';
import AdmissionProfile from './AdmissionProfile/AdmissionProfile';
import Subjects from './Subjects/Subjects';
import DownloadFile from './DownloadFile/DownloadFile';
import Teachers from './Teachers/Teachers';

import classes from './BottomSection.module.css';

const BottomSection = ({ productData }) => {
  console.log('🚀 ~ BottomSection ~ productData:', productData);
  return (
    <div className={classes.bottomContainer}>
      <div className={classes.academicContainer}>
        <p className={classes.academicText}>
          OBTENCIÓN DE GRADO ACADÉMICO
        </p>
        <p className={classes.academicDescription}>
          {productData.academicGrade}
        </p>
      </div>
      <div className={classes.section}>
        <p className={classes.sectionTitle}>Objetivo del programa</p>
        {productData.objective.map(item => (
          <p key={item}>{item}</p>
        ))}
      </div>
      <ProductIncludes productData={productData} />
      <AdmissionProfile productData={productData} />
      <GraduationProfile productData={productData} />
      <Subjects productData={productData} />
      {productData.teachers && (
        <Teachers productData={productData} />
      )}
      {productData.downloadFiles.length > 0 && (
        <DownloadFile productData={productData} />
      )}
    </div>
  );
};

BottomSection.propTypes = {
  // eslint-disable-next-line react/require-default-props
  productData: PropTypes.object
};

export default BottomSection;
